const PRECISION = 1e-9;
const isEqualWithinPrecision = (a, b, precision = PRECISION)=>Math.abs(a - b) < precision;
const isGreaterThanWithinPrecision = (a, b, precision = PRECISION)=>a > b + precision;
const isLessThanWithinPrecision = (a, b, precision = PRECISION)=>a < b - precision;
export const findCircleIntersections = (circleA, circleB)=>{
    const { center: { x: x1, y: y1 }, radius: r1 } = circleA;
    const { center: { x: x2, y: y2 }, radius: r2 } = circleB;
    // Calculate the distance between the centers
    const d = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    // Check for no intersection (too far apart or one circle inside the other)
    if (isGreaterThanWithinPrecision(d, r1 + r2) || isLessThanWithinPrecision(d, Math.abs(r1 - r2))) {
        return [];
    }
    // Check if the circles are coincident (infinite number of intersections)
    if (isEqualWithinPrecision(d, 0) && isEqualWithinPrecision(r1, r2)) {
        return [];
    }
    // Calculate the distance from the first circle's center to the line connecting the points of intersection
    const a = (r1 ** 2 - r2 ** 2 + d ** 2) / (2 * d);
    // Height of the intersection points above the line
    const hv = Math.abs(r1 ** 2 - a ** 2);
    const h = hv < PRECISION ? 0 : Math.sqrt(hv);
    // Coordinates of the point P, which lies on the line between the circle centers
    const xP = x1 + a * (x2 - x1) / d;
    const yP = y1 + a * (y2 - y1) / d;
    // Intersection points (x3, y3) and (x4, y4)
    const x3 = xP + h * (y2 - y1) / d;
    const y3 = yP - h * (x2 - x1) / d;
    const x4 = xP - h * (y2 - y1) / d;
    const y4 = yP + h * (x2 - x1) / d;
    // Return a single intersection point
    if (isEqualWithinPrecision(x3, x4) && isEqualWithinPrecision(y3, y4)) {
        return [
            {
                x: x3,
                y: y3
            }
        ];
    }
    // Return two intersection points
    return [
        {
            x: x3,
            y: y3
        },
        {
            x: x4,
            y: y4
        }
    ];
};

//# sourceMappingURL=utils.js.map